import { render } from "./HelloWorld.vue?vue&type=template&id=bd4822be&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=bd4822be&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bd4822be"

export default script